import { render } from "./index.vue?vue&type=template&id=6d7f99e3&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "@/assets/scss/common/tab/tab-swift.scss?vue&type=style&index=0&id=6d7f99e3&scoped=true&lang=scss"
import "@/assets/scss/results/results.scss?vue&type=style&index=1&id=6d7f99e3&scoped=true&lang=scss"

import exportComponent from "/Users/thanhnguyen/Desktop/ThanhNguyen/projects/public_html/numbers-betting-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d7f99e3"]])

export default __exports__